import type { ReactNode } from 'react';

import {
  getFileIcon,
  getFileIconBackgroundColor,
} from '@/constants/node-styling';
import { cn } from '@/lib/utils';

interface FileChipProps {
  filename: string;
  /** Rendered after the filename — size, upload state, a remove button. */
  trailing?: ReactNode;
  /** Replaces the file-type glyph, e.g. with a spinner while uploading. */
  icon?: ReactNode;
  className?: string;
  title?: string;
}

export function FileChip({
  filename,
  trailing,
  icon,
  className,
  title,
}: FileChipProps) {
  const Icon = getFileIcon(filename);
  const accent = getFileIconBackgroundColor(filename);

  return (
    <span
      title={title}
      className={cn(
        'inline-flex max-w-full items-center gap-2 rounded-xl bg-accent py-1.5 pl-1.5 pr-3 text-base text-foreground',
        className,
      )}
    >
      <span
        className='flex size-8 shrink-0 items-center justify-center rounded-md'
        style={{ backgroundColor: accent }}
      >
        {icon ?? <Icon className='size-5 text-white' />}
      </span>
      <span className='min-w-0 max-w-64 truncate'>{filename}</span>
      {trailing}
    </span>
  );
}
